// ==== FRONTEND: Step1Form.jsx ====
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api';
import DashboardLayout from './DashboardLayout';

function Step1Form() {
  const [title, setTitle] = useState('');
  const [shortDesc, setShortDesc] = useState('');
  const [mainImage, setMainImage] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('title', title);
    formData.append('shortDesc', shortDesc);
    if (mainImage) formData.append('mainImage', mainImage);

    try {
      const res = await api.post('/articles/step1', formData);
      navigate(`/articles/step2/${res.data.id}`);
    } catch (err) {
      console.error(err);
      alert('Failed to create article.');
    }
  };

  return (
    <DashboardLayout>
      <main className="main-container">
        <form onSubmit={handleSubmit} className="p-4 max-w-xl mx-auto">
          <h2 className="text-xl font-bold mb-4">Step 1: Article Info</h2>
          <input
            type="text"
            placeholder="Title"
            value={title}
            onChange={e => setTitle(e.target.value)}
            className="w-full p-2 mb-2 border"
            required
          />
          <textarea
            placeholder="Short Description"
            value={shortDesc}
            onChange={e => setShortDesc(e.target.value)}
            className="w-full p-2 mb-2 border h-24"
            required
          />
          <input
            type="file"
            onChange={e => setMainImage(e.target.files[0])}
            className="mb-4"
            required
          />
          <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded">
            Continue
          </button>
        </form>
      </main>
    </DashboardLayout>
  );
}

export default Step1Form;
